import type { StatisticState } from './slices';
import { categorySlice, filtersSlice, orderSlice, sortingSlice } from './slices';
import type { StatisticOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: StatisticProvider,
  useStore: useStatsStore,
  createStore: createStatsStore,
} = zustandStoreFactory<StatisticState>(
  (...args) => ({
    ...categorySlice(...args),
    ...filtersSlice(...args),
    ...sortingSlice(...args),
    ...orderSlice(...args),
  }),
  'Statistic',
);

export const { OptionsProvider: StatisticOptionsProvider, useOptions: useStatisticOptions } =
  getOptionsProvider<StatisticOptions>();
